(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oc-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-oc-reviews-root]');
    if (!root || !window.fetch) return;

    var STRINGS = {};
    try {
      STRINGS = JSON.parse(root.querySelector('[data-oc-reviews-strings]').textContent);
    } catch (e) {
      return;
    }

    var ENDPOINT = root.dataset.endpoint;
    var SHOW_COUNTRY = root.dataset.showCountry === '1';
    // Six on the desktop grid fills two clean rows of three; the phone stacks
    // them, so five is enough before the fold gets silly.
    var DESKTOP_FEATURED = parseInt(root.dataset.featuredDesktop, 10) || 6;
    var MOBILE_FEATURED = parseInt(root.dataset.featuredMobile, 10) || 5;
    var grid = window.matchMedia('(min-width: 750px)');

    function featuredCount() {
      return grid.matches ? DESKTOP_FEATURED : MOBILE_FEATURED;
    }
    var LOCALE = STRINGS.locale || document.documentElement.lang || 'nl';
    var LANG = (document.documentElement.lang || LOCALE).slice(0, 2).toLowerCase();
    var CACHE_KEY = 'oc_reviews_rel_v2_' + LANG;
    var TTL_MS = 30 * 60 * 1000;
    var AVATAR_COLORS = ['#d96941', '#4a90a4', '#6aaa7a', '#8c7355', '#c58a4a', '#7a6f9b'];

    var els = {
      avg: root.querySelector('[data-oc-avg]'),
      avgStars: root.querySelector('[data-oc-avg-stars]'),
      countLine: root.querySelector('[data-oc-count-line]'),
      recent: root.querySelector('[data-oc-recent]'),
      dist: root.querySelector('[data-oc-dist]'),
      distRows: root.querySelector('[data-oc-dist-rows]'),
      rail: root.querySelector('[data-oc-list]'),
      empty: root.querySelector('[data-oc-empty]'),
      toggle: root.querySelector('[data-oc-toggle]')
    };

    var state = { data: null, filter: null, expanded: false, useRelevance: false };

    function fmt(n, minFrac, maxFrac) {
      try {
        return new Intl.NumberFormat(LOCALE, {
          minimumFractionDigits: minFrac,
          maximumFractionDigits: maxFrac
        }).format(n);
      } catch (e) {
        return String(n);
      }
    }

    function fmtDate(iso) {
      try {
        return new Intl.DateTimeFormat(LOCALE, {
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        }).format(new Date(iso + 'T00:00:00Z'));
      } catch (e) {
        return iso;
      }
    }

    function fill(tpl, map) {
      var out = String(tpl || '');
      for (var k in map) {
        if (Object.prototype.hasOwnProperty.call(map, k)) out = out.split(k).join(map[k]);
      }
      return out;
    }

    // The API ranks written reviews with a `relevance` score. That scoring is
    // still being built, so while every value comes back 0 this falls back to
    // text length as a stand-in. Real scores take over on their own.
    function score(r) {
      if (state.useRelevance) return r.relevance || 0;
      return Math.min((r.text || '').length, 400);
    }

    function newestFirst(a, b) {
      return String(b.submitted_at).localeCompare(String(a.submitted_at));
    }

    // The visitor's own language comes first, ranked by relevance inside it,
    // then the other languages by relevance. A French review is still real
    // proof, but it should not outrank a Dutch one on a Dutch page.
    // A translated review reads natively, so it ranks with the visitor's own
    // language rather than being pushed behind it.
    function langRank(r) {
      if (r.language === LANG) return 0;
      if (r.text_original && r.original_language) return 0;
      return 1;
    }

    function byRelevance(a, b) {
      if (langRank(a) !== langRank(b)) return langRank(a) - langRank(b);
      if (score(b) !== score(a)) return score(b) - score(a);
      return newestFirst(a, b);
    }

    // Full list: the visitor's language first, then best ratings, then the
    // most relevant within a rating.
    function byRating(a, b) {
      if (langRank(a) !== langRank(b)) return langRank(a) - langRank(b);
      if (b.rating !== a.rating) return b.rating - a.rating;
      if (score(b) !== score(a)) return score(b) - score(a);
      return newestFirst(a, b);
    }

    function all() {
      return (state.data.reviews || []).slice();
    }

    // Featured is simply the highest-relevance reviews, in that order.
    function featured(rows) {
      return rows.slice().sort(byRelevance).slice(0, featuredCount());
    }

    function visible() {
      var rows = all();

      if (state.filter != null) {
        // A star filter is an explicit request to see that bucket, all of it.
        return rows
          .filter(function (r) { return r.rating === state.filter; })
          .sort(byRelevance);
      }

      return state.expanded ? rows.sort(byRating) : featured(rows);
    }

    function starsInto(el, rating, rounded) {
      el.textContent = '';
      var value = rounded ? Math.round(rating * 2) / 2 : rating;
      for (var i = 1; i <= 5; i++) {
        var star = document.createElement('span');
        star.className = 'oc-star' + (i <= Math.round(value) ? ' oc-star--on' : '');
        star.textContent = '★';
        el.appendChild(star);
      }
    }

    function languageName(code) {
      return STRINGS.languages[code] || code.toUpperCase();
    }

    function avatarColor(name) {
      var sum = 0;
      for (var i = 0; i < name.length; i++) sum += name.charCodeAt(i);
      return AVATAR_COLORS[sum % AVATAR_COLORS.length];
    }

    function renderSummary() {
      var s = state.data.summary;
      if (!s || s.average == null) return;

      els.avg.textContent = fmt(s.average, 1, 2);
      starsInto(els.avgStars, s.average, true);
      els.countLine.textContent = fill(STRINGS.basedOn, { '%COUNT%': fmt(s.count, 0, 0) });

      // Recency is the trust signal buyers weigh hardest: a good score from
      // this month beats a better score from two years ago.
      var recent = s.last_30_days;
      if (recent && recent.count) {
        els.recent.textContent = fill(STRINGS.lastThirty, {
          '%COUNT%': fmt(recent.count, 0, 0),
          '%RATING%': fmt(recent.average, 1, 2)
        });
        els.recent.hidden = false;
      } else {
        els.recent.hidden = true;
      }
    }

    // Rows are built once and only their pressed state changes afterwards, so
    // filtering with the keyboard never tears the focused button out of the DOM.
    var distRows = [];

    function buildDist() {
      var s = state.data.summary;
      var dist = (s && s.distribution) || {};
      var total = s && s.count ? s.count : 0;
      els.distRows.textContent = '';
      distRows = [];

      for (var star = 5; star >= 1; star--) {
        (function (star) {
          var count = dist[String(star)] || 0;
          var pct = total ? (count / total) * 100 : 0;

          var row = document.createElement('button');
          row.type = 'button';
          row.className = 'oc-dist-row';
          row.setAttribute('aria-pressed', 'false');
          row.setAttribute('aria-label', fill(STRINGS.filterOne, { '%N%': star }));

          var label = document.createElement('span');
          label.className = 'oc-dist-row__label';
          label.textContent = star + ' ';
          var glyph = document.createElement('span');
          glyph.className = 'oc-star';
          glyph.textContent = '★';
          label.appendChild(glyph);

          var track = document.createElement('span');
          track.className = 'oc-dist-row__track';
          var bar = document.createElement('span');
          bar.className = 'oc-dist-row__fill';
          bar.style.width = pct.toFixed(1) + '%';
          track.appendChild(bar);

          var cnt = document.createElement('span');
          cnt.className = 'oc-dist-row__count';
          cnt.textContent = fmt(count, 0, 0);

          row.appendChild(label);
          row.appendChild(track);
          row.appendChild(cnt);

          // Clicking the active row again clears the filter.
          row.addEventListener('click', function () {
            state.filter = state.filter === star ? null : star;
            updateDist();
            renderList();
          });

          distRows.push({ star: star, el: row });
          els.distRows.appendChild(row);
        })(star);
      }

      els.dist.hidden = false;
    }

    function updateDist() {
      distRows.forEach(function (r) {
        r.el.setAttribute('aria-pressed', state.filter === r.star ? 'true' : 'false');
      });
    }

    function renderCard(r) {
      var card = document.createElement('article');
      card.className = 'oc-review';

      var stars = document.createElement('span');
      stars.className = 'oc-review__stars';
      stars.setAttribute('aria-label', fill(STRINGS.starsLabel, { '%N%': r.rating }));
      starsInto(stars, r.rating, false);
      card.appendChild(stars);

      var body = document.createElement('p');
      body.className = 'oc-review__body';
      body.textContent = r.text;
      card.appendChild(body);

      // A translated review is never passed off as original: the source
      // language is named and the original stays one click away.
      var source = r.original_language;
      if (source && source !== LANG && r.text_original) {
        body.lang = LANG;

        var note = document.createElement('p');
        note.className = 'oc-review__translated';

        var label = document.createElement('span');
        label.textContent = fill(STRINGS.translatedFrom, { '%LANG%': languageName(source) });
        note.appendChild(label);

        var sep = document.createElement('span');
        sep.className = 'oc-review__sep';
        sep.textContent = '·';
        note.appendChild(sep);

        var toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'oc-review__original-toggle';
        toggle.textContent = STRINGS.showOriginal;
        toggle.setAttribute('aria-expanded', 'false');

        var showingOriginal = false;
        toggle.addEventListener('click', function () {
          showingOriginal = !showingOriginal;
          body.textContent = showingOriginal ? r.text_original : r.text;
          body.lang = showingOriginal ? source : LANG;
          toggle.textContent = showingOriginal ? STRINGS.showTranslation : STRINGS.showOriginal;
          toggle.setAttribute('aria-expanded', showingOriginal ? 'true' : 'false');
        });

        note.appendChild(toggle);
        card.appendChild(note);
      } else if (r.language && r.language !== LANG) {
        body.lang = r.language;
      }

      var meta = document.createElement('div');
      meta.className = 'oc-review__meta';

      var name = r.author || r.first_name || '';
      var avatar = document.createElement('span');
      avatar.className = 'oc-review__avatar';
      avatar.setAttribute('aria-hidden', 'true');
      avatar.style.background = avatarColor(name);
      avatar.textContent = name.charAt(0);
      meta.appendChild(avatar);

      var who = document.createElement('span');
      who.className = 'oc-review__who';

      var nameEl = document.createElement('span');
      nameEl.className = 'oc-review__name';
      nameEl.textContent = name;
      who.appendChild(nameEl);

      var sub = document.createElement('span');
      sub.className = 'oc-review__sub';
      var bits = [];
      if (SHOW_COUNTRY && r.country) bits.push(r.country);
      if (r.date) bits.push(fmtDate(r.date));
      sub.textContent = bits.join(' · ');
      if (bits.length) sub.appendChild(document.createTextNode(' · '));
      var verified = document.createElement('span');
      verified.className = 'oc-review__verified';
      verified.textContent = '✓ ' + STRINGS.verified;
      sub.appendChild(verified);
      who.appendChild(sub);

      meta.appendChild(who);
      card.appendChild(meta);
      return card;
    }

    function renderList() {
      var rows = visible();
      els.rail.textContent = '';

      if (!rows.length) {
        var s = state.data.summary;
        var dist = (s && s.distribution) || {};
        var given = state.filter == null ? 0 : dist[String(state.filter)] || 0;
        els.empty.textContent = given
          ? fill(STRINGS.empty, { '%COUNT%': fmt(given, 0, 0), '%N%': state.filter })
          : fill(STRINGS.emptyZero, { '%N%': state.filter });
        els.empty.hidden = false;
        els.rail.hidden = true;
        els.toggle.hidden = true;
        return;
      }

      els.empty.hidden = true;
      els.rail.hidden = false;
      rows.forEach(function (r) { els.rail.appendChild(renderCard(r)); });

      renderToggle();
    }

    function renderToggle() {
      var total = all().length;

      // Under a star filter the bucket is already shown whole.
      if (state.filter != null || total <= featuredCount()) {
        els.toggle.hidden = true;
        return;
      }

      els.toggle.hidden = false;
      els.toggle.setAttribute('aria-expanded', state.expanded ? 'true' : 'false');
      els.toggle.textContent = state.expanded
        ? STRINGS.showLess
        : fill(STRINGS.showAll, { '%COUNT%': fmt(total, 0, 0) });
    }

    els.toggle.addEventListener('click', function () {
      state.expanded = !state.expanded;
      renderList();
    });

    function onBreakpoint() {
      if (state.data && !state.expanded) renderList();
    }

    if (grid.addEventListener) {
      grid.addEventListener('change', onBreakpoint);
    } else if (grid.addListener) {
      grid.addListener(onBreakpoint);
    }

    // Google reads the product markup the theme already emits; the ratings are
    // merged into that node rather than added as a second, competing one.
    function injectStructuredData() {
      var s = state.data.summary;
      if (!s || s.average == null || !s.count) return;

      var scripts = document.querySelectorAll('script[type="application/ld+json"]');
      for (var i = 0; i < scripts.length; i++) {
        var node;
        try {
          node = JSON.parse(scripts[i].textContent);
        } catch (e) {
          continue;
        }
        if (!node || (node['@type'] !== 'Product' && node['@type'] !== 'ProductGroup')) continue;

        node.aggregateRating = {
          '@type': 'AggregateRating',
          ratingValue: s.average,
          reviewCount: s.count,
          bestRating: 5,
          worstRating: 1
        };

        node.review = all().sort(byRating).slice(0, 10).map(function (r) {
          return {
            '@type': 'Review',
            reviewRating: { '@type': 'Rating', ratingValue: r.rating, bestRating: 5, worstRating: 1 },
            author: { '@type': 'Person', name: r.author || r.first_name || '' },
            datePublished: r.date,
            reviewBody: r.text
          };
        });

        scripts[i].textContent = JSON.stringify(node);
        return;
      }
    }

    function render() {
      renderSummary();
      buildDist();
      updateDist();
      renderList();
      injectStructuredData();
    }

    function readCache() {
      try {
        var raw = sessionStorage.getItem(CACHE_KEY);
        if (!raw) return null;
        var hit = JSON.parse(raw);
        if (hit && Date.now() - hit.t < TTL_MS) return hit.d;
      } catch (e) {}
      return null;
    }

    function writeCache(data) {
      try {
        sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), d: data }));
      } catch (e) {}
    }

    function boot(data) {
      if (!data || !data.summary) return;
      state.data = data;
      state.useRelevance = (data.reviews || []).some(function (r) {
        return typeof r.relevance === 'number' && r.relevance > 0;
      });
      render();
    }

    var cached = readCache();
    if (cached) {
      boot(cached);
    } else {
      fetch(ENDPOINT + '?limit=100&sort=relevance&translate=' + LANG, { credentials: 'omit' })
        .then(function (res) { return res.ok ? res.json() : Promise.reject(res.status); })
        .then(function (data) {
          writeCache(data);
          boot(data);
        })
        .catch(function () { /* server-rendered header stays as the fallback */ });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
